<script>
export default {
  name: "EditInDjangoAdmin",
  props: {
    app: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    adminUrl() {
      const base = this.baseUrl || window.location.origin;
      return `${base}/admin/${this.app}/${this.model}/${this.id}/change/`;
    }
  },
  methods: {
    openDjangoAdmin() {
      window.open(this.adminUrl, '_blank', 'noopener,noreferrer');
    }
  }
}
</script>

<template>
  <button
      :title="`Open this ${model} in Django admin`"
      class="django-admin-button"
      type="button"
      @click="openDjangoAdmin"
  >
    <svg class="django-icon" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M9.4 2.2v9.9c-1.1.2-1.9.3-2.8.3-2.6 0-4-1.2-4-3.5 0-2.2 1.4-3.6 3.7-3.6.3 0 .6 0 .9.1V2.2h2.2Zm-2.9 4.9c-1.1 0-1.7.7-1.7 1.8s.6 1.8 1.7 1.8c.2 0 .4 0 .7-.1V7.2c-.3-.1-.5-.1-.7-.1Z"/>
      <path d="M12.6 5.3v5c0 1.7-.1 2.5-.5 3.2-.3.7-.8 1.1-1.7 1.6l-2-.9c.9-.5 1.4-.9 1.7-1.5.3-.6.3-1.3.3-3.2v-4.2h2.2Z"/>
      <path d="M12.6 2.2v2.2h-2.2V2.2h2.2Z"/>
    </svg>
  </button>
</template>

<style scoped>
/* A developer shortcut sitting inside a game master's list. It is sized in px
   rather than vh — it used to grow and shrink with the window height — and it
   stays quiet in the panel's own palette instead of shipping Django's green
   into a gold theme. */
.django-admin-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 22px;
  height: 22px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--gm-border-dim);
  border-radius: var(--gm-radius-sm);
  color: var(--gm-text-dim);
  cursor: pointer;
  transition: color var(--gm-duration) var(--gm-ease),
              border-color var(--gm-duration) var(--gm-ease),
              background var(--gm-duration) var(--gm-ease);
}

.django-admin-button:hover {
  color: var(--gm-accent);
  border-color: var(--gm-border);
  background: var(--gm-accent-softer);
}

.django-admin-button:focus-visible {
  outline: none;
  border-color: var(--gm-border-hi);
}

.django-icon {
  width: 12px;
  height: 12px;
  fill: currentColor;
}

@media (prefers-reduced-motion: reduce) {
  .django-admin-button {
    transition: none;
  }
}
</style>
